import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Sheet from "react-modal-sheet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import ArrowLeft from "../../assets/images/Arrow-left.svg";
import dropdown1 from "../../assets/images/dropdown.svg";
import home from "../../assets/images/HomeDisable.svg";
import idea from "../../assets/images/idea1.svg";
import top_btn from "../../assets/images/top_btn.svg";
import left from "../../assets/images/left.svg";
import Backicon from "../../assets/images/mobback.svg";
import rightArr from "../../assets/images/navRight.svg";
import One from "../../assets/images/one.svg";
import ficon from "../../assets/images/popularS.svg";
import right from "../../assets/images/right.svg";
import Search from "../../assets/images/search.svg";
import Stepone from "../../assets/images/stepone.svg";
import Steptwo from "../../assets/images/steptwo.svg";
import stepthree from '../../assets/images/stepthree.png'
import Three from "../../assets/images/three.svg";
import Two from "../../assets/images/two.svg";
import {
  AlphabeticalFilter,
  Card,
  CardSelectedTest,
  CardSelectTest,
  Filter,
  MobileCardSelectedTest,
  Popup,
  SliderComponent,
  Toast,
} from "../../components";
import Chat from "../../components/Chat/Chat";
import LoaderComponent from "../../components/Loading/LoaderComponent";
import Layout from "../../layout";
import {
  clearTest,
  featureRemoveTest,
  removeTest,
  testValue,
} from "../../redux/auth/actions";
import axios from "../../redux/axios";
import PartnerSlider from "../Landing/PartnerSlider";
import "./styles.scss";

const tempdata = ["1", "2", "3", "4"];
const PopularTest = (props) => {
  console.log(
    props?.location?.state, "rdyhfjgfjg"
  );
  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );
  const focusPoint = useRef(null);
  const dummyArrayValue = [...Array(30)];
  const { search } = useSelector((state) => state.auth);
  const [ShowLocation, setShowLocation] = useState(false);
  const [alertShowLocation, setalertShowLocation] = useState(false);
  const [alertShowLocation1, setalertShowLocation1] = useState(false);


  const [selectedRec, setSelectedRec] = useState([]);

  const [update, setUpdate] = useState(false);
  const [ShowArea, setShowArea] = useState(false);
  const [key, setKey] = useState("pathology");
  const [rangeFilter, setRangFilter] = useState("A-Z");
  const [arrIndex, setArrIndex] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterValue, setFilterValue] = useState(props?.location?.state ? props?.location?.state : "pathology");
  const [inputSearch, setInputSearch] = useState("");
  const [btn, setBtn] = useState(false);
  const [btmLocationSheet, setbtmLocationSheet] = useState(false);
  const cities = useSelector((state) => state.auth.cities);

  const [testListing, setTestListing] = useState([]);
  const [allTestRange, setAllTestRange] = useState("A-Z");
  const [count, setCount] = useState(0);
  const [count1, setCount1] = useState(0);
  const [locPop, setLocPop] = useState(false);
  const [pageno, setPageno] = useState(0);
  const [partner, setPartner] = useState([]);
  const [area, setArea] = useState("");
  const [mobileView, setMobileView] = useState(false);
  const [mobileTestpopstate, setMobiletestpopstate] = useState(false);
  const [popularTest, setPopularTest] = useState([]);
  const [btnselect, setBtnselect] = useState("");
  const dispatch = useDispatch();
  const [areaId, setAreaId] = useState("");
  const sheetRef = useRef();
  const cityState = useSelector((state) =>
    state.city != undefined && state.city.label != undefined ? state.city : ""
  );
  const areaState = useSelector((state) =>
    state.area != undefined && state.area.area != undefined
      ? state.area.area
      : ""
  );

  const [btmSheet, setbtmSheet] = useState(false);
  const globalSearch = useSelector((state) => state.auth.search);
  const [searchData, setSearchData] = useState([]);

  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const test = useSelector((state) => state);

  const history = useHistory();

  const lanTestes = history.location.state;

  const arealocal = useSelector((state) => state.area);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (areaState.value === undefined) {
      setAreaId("");
    } else {
      setAreaId(areaState.value);
      setArea(areaState.value);
    }
  }, [areaState]);
  const handleLocPop = () => {
    ShowLocation === true ? setShowLocation(false) : setShowLocation(true);
  };
  const selectTest = (i, value) => {
    if (arealocal.area.value === "") {
      dispatch(clearTest());
      // setShowLocation(true);
      setalertShowLocation(true)
    } else {
      selectedRec.push(value);
      dispatch(testValue(value));
      arrIndex.push(i);
      setUpdate(!update);
    }
  };
  const [showCard, setShowCard] = useState(false);
  const delSelectedTest = (v) => {
    const newArr = selectedRec.filter((object) => {
      return object.doc?.uuid !== v.doc.uuid;
    });
    setSelectedRec(newArr);
    dispatch(removeTest(v.doc.uuid));
  };

  // useEffect(() => {
  //   setSelectedRec(selected_test)
  // }, [])

  const handlleRemoveTest = (v) => {
    dispatch(featureRemoveTest(v.uuid));
  };
  const handleLocationClose = () => {
    setShowLocation(false);
  };
  const handleLocationOpen = () => {
    setalertShowLocation(false);
    setShowLocation(true);
  };
  const handlealertLocationClose = () => {
    setalertShowLocation(false);
  };
  const handleLocationOpen1 = () => {
    setalertShowLocation1(false);
    setShowLocation(true);
  };
  const handlealertLocationClose1 = () => {
    setalertShowLocation1(false);
  };
  const handleAreaClose = () => {
    setShowArea(false);
  };

  useEffect(() => {
    // setFilterData([])
    setPopularTest([]);
    axios
      .get(
        `${process.env.REACT_APP_API_URL
        }/labtest/diagnostic/filterLists?type=${filterValue}&value=${inputSearch}&area=${arealocal && arealocal.area && arealocal.area.value
        }&filter=${rangeFilter}&is_popular=YES&pagenum=${count1}&limit=10`
      )
      .then((res) => {
        // setFilterData(res.data.data)
        setPopularTest(res.data);
      })
      .catch((err) => console.log(err));
  }, [filterValue, rangeFilter, count1, areaState, inputSearch]);
  console.log(count1, "gdfgdgdfgdfg")

  const handleCount1 = (v) => {
    window.scrollTo(0, 750);
    const result = count1 + v;
    setPopularTest([]);
    console.log(popularTest, "fh");
    if (result > 0) {
      setCount1(result);
    } else {
      setCount1(0);
    }
  };
  // useEffect(() => {
  //   // setFilterData([])
  //   setPopularTest([]);
  //   console.log(inputSearch)
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}/labtest/diagnostic/searchLists?value=${inputSearch}`
  //     )
  //     .then((res) => {
  //       // setFilterData(res.data.data)
  //       setPopularTest(res.data);
  //     })
  //     .catch((err) => console.log(err));
  // }, [filterValue, inputSearch, count, areaState]);

  const searchFilter =
    filterData !== undefined
      ? filterData.filter((res) =>
        res.doc.standardisedtestname
          .toString()
          .toLowerCase()
          .includes(inputSearch.toString().toLowerCase())
      )
      : [];


  // handle data form landing page
  React.useEffect(() => {
    if (lanTestes) {
      console.log(lanTestes, "lanTestes");
      let data = selectedRec;
      console.log(data, "lanTestes");
      // if(selectedRec <= 1)
      // {
      //   let data = selectedRec && selectedRec[0] && selectedRec[0].data && selectedRec[0].data
      setSelectedRec(data);
      // }
      // else {
      //   let data = selectedRec && selectedRec[0] && selectedRec[0].data && selectedRec[0].data
      //   setSelectedRec(data);
      // }

      setUpdate(!update);
    }
  }, []);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/labtest/diagnostic/filterListAllTests?type=${filterValue}&filter=${allTestRange}&pagenum=${count}&limit=10`
      )
      .then((res) => {
        setTestListing(res.data, "data from all list");
        console.log(res.data, "fh");
      })
      .catch((err) => console.log(err));
  }, [filterValue, allTestRange, count]);

  const handleCount = (v) => {
    const result = count + v;
    setTestListing([]);
    if (result > 0) {
      setCount(result);
    } else {
      setCount(0);
    }
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
      .then((res) => setPartner(res.data))
      .catch((err) => console.log(err.resp));
  }, []);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 600
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  const handlemobileTestpop = () => {
    setMobiletestpopstate(false);
  };
  console.log(window, "Windows.location.pathname ")
  // useEffect(() => {
  //   setSearchData([])
  //   if (inputSearch.length !== 0) {
  //     let searchTerm = inputSearch ? inputSearch : '';

  //     axios
  //       .get(
  //         `${process.env.REACT_APP_API_URL}/labtest/diagnostic/filterLists?type=${filterValue}&value=&area=${arealocal.area.value}&filter=${rangeFilter}&pagenum=0&limit=10&search=${searchTerm}`
  //       )
  //       .then((res) => setSearchData(res.data.data))
  //       .catch((err) => console.log(err));
  //   } else {
  //     setSearchData([])
  //   }
  // }, [inputSearch]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (globalSearch !== undefined) {
  //       if (globalSearch.uuid !== undefined) {
  //         setLoading(true);
  //         if (globalSearch.uuid.charAt(1) === "R") {
  //           axios
  //             .get(
  //               `${process.env.REACT_APP_API_URL}/labtest/diagnostic/centeralized/search?type=radiology&value=${globalSearch.uuid}&area=${arealocal.area.value}&filter=${rangeFilter}&pagenum=0&limit=10`
  //             )
  //             .then((res) => {
  //               if (res.status === 200 && res.data.data) {
  //                 setSearchData(res.data.data);
  //                 setToastOpen(false);
  //                 window.scrollTo(0, focusPoint.current.offsetTop);
  //               } else {
  //                 setToastOpen(true);
  //                 setToastMessage(
  //                   "Searched Test Is not available for saved location"
  //                 );
  //                 setSearchData([]);
  //               }
  //               dispatch(clearSearch());
  //               setLoading(false);
  //             })
  //             .catch((error) => {
  //               if (error && error.response) {
  //                 setToastOpen(true);
  //                 setToastMessage("" + error.response.data);
  //               }
  //               setLoading(false);
  //             });
  //         } else {
  //           // axios.get(`${process.env.REACT_APP_API_URL}/labtest/diagnostic/filterLists?type=pathology&value=${globalSearch.uuid}&area=${arealocal.area.value}&filter=A-Z&pagenum=0&limit=8`)
  //           axios
  //             .get(
  //               `${process.env.REACT_APP_API_URL}/labtest/diagnostic/centeralized/search?type=pathology&value=${globalSearch.uuid}&area=${arealocal.area.value}&filter=A-Z&pagenum=0&limit=8`
  //             )
  //             .then((res) => {
  //               if (res.status === 200 && res.data.data) {
  //                 setSearchData(res.data.data);
  //                 setToastOpen(false);
  //                 window.scrollTo(0, focusPoint.current.offsetTop);
  //               } else {
  //                 setSearchData([]);
  //                 setToastOpen(true);
  //                 setToastMessage(
  //                   "Searched Test Is not available for saved location"
  //                 );
  //               }
  //               setLoading(false);
  //               dispatch(clearSearch());
  //             })
  //             .catch((error) => {
  //               if (error && error.response) {
  //                 setToastOpen(true);
  //                 setToastMessage("" + error.response.data);
  //               }
  //               setLoading(false);
  //             });
  //         }
  //       }
  //     }
  //   }, 500);
  // }, [globalSearch]);

  // useEffect(() => {
  //   axios.get(`${process.env.REACT_APP_API_URL}/labtest/diagnostic/filterLists?type=${filterValue}&value=&area=${arealocal.area.value}&filter=${rangeFilter}&pagenum=0&limit=10`)
  //     .then((res) => setFilterData(res.data.data),
  //   )
  //     .catch((err) => console.log(err));
  // }, [areaState])

  return (
    <>

      <Layout>
        {window.location.pathname === ""}
        <Helmet>
          <title>Search for test, filter for easy access and buy
          </title>
          <meta
            name='description'
            content='Shop for a wide range of tests from Diagnostic Marketplace. Get the best deals, have test results delivered to you'
          />
        </Helmet>
        <div className="popularContainer">
          {!mobileView ? (
            <>
              <div className="title">
                <img
                  src={home}
                  alt="icon"
                  onClick={() => {
                    history.push("/");
                  }}
                />
                <img src={rightArr} alt="icon" />
                Diagnostic Tests
              </div>{" "}
              <div className="steps_to_follow">
                <div className="header">Steps to Follow</div>
                <div className="pt_card_container">
                  <div className="card_container">
                    <img src={One} alt="icon" />
                    Search for your test
                  </div>
                  <div className="card_container">
                    <img src={Two} alt="icon" />
                    Select your location
                  </div>
                  <div className="card_container">
                    <img src={Three} alt="icon" />
                    Compare prices and buy
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="mobile-view-popular-outer-cls">
              <div
                className="header-back-row"
                onClick={() => {
                  history.goBack();
                }}
              >
                <img src={Backicon} alt="Backicon" />
                <div className="back-text">Back</div>
              </div>
              <div className="steps-container-out">
                <div className="head-font">Steps to Follow</div>
                <div className="step-one-cls">
                  <img src={Stepone} alt="Stepone" />
                  <div className="right-cls">
                    <span>Search for your test.</span>
                    <br /> You can locate your desires test using the
                    alphabetical filter
                  </div>
                </div>
                <div className="step-two-cls">
                  <img src={Steptwo} alt="Stepone" />
                  {/* <div className="right-cls">Select test and buy</div> */}
                  <div className="right-cls">Select your location</div>
                </div>
                <div className="step-two-cls">
                  <img src={stepthree} alt="stepthree" style={{ width: "30px", height: "30px", marginLeft: "5px" }} />
                  {/* <div className="right-cls">Select test and buy</div> */}
                  <div className="right-cls">Compare prices and buy</div>
                </div>
              </div>
            </div>
          )}
          <div className="page_container">
            <div className="btn-wrap">
              <div
                className={filterValue === "pathology" ? "btn btnAction" : "btn btnNoAction"}
                onClick={() => {
                  setBtn(!btn);
                  setFilterValue("pathology");
                }}
              >
                PATHOLOGY
              </div>
              <div
                className={filterValue === "radiology" ? "btn btnAction" : "btn btnNoAction"}
                onClick={() => {
                  setBtn(!btn);
                  setFilterValue("radiology");
                }}

              >
                RADIOLOGY
              </div>
            </div>
            {/* <div className="item_container">
              <div className="input_Container">
                <img src={Search} alt="icon" />
                <input
                  type="text"
                  className="input_search"
                  placeholder="Search tests"
                  value={inputSearch}
                  // setFilterData(searchFilter)
                onInput={(e) => setFilterData(searchFilter)}
                // onInput={searchFilter}
                  onChange={(e) => setInputSearch(e.target.value)}
                />
              </div>
              <div className="tips_container">
                <div className="heading_container">
                  <img src={idea} alt="icon" />
                  <div className="heading">Help Tip</div>
                </div>
                <div className="txt">
                  Use the search bar to find the test you want.
                </div>
              </div>
            </div> */}

            {/* Popular Test Section */}

            <div className="input_containerrr">
              <div className="leftContainer">
                <div className="heading_container">
                  <div className="heading">MOST POPULAR TESTS</div>
                  <div className="txt">
                    Browse through our common/popular tests
                  </div>
                </div>
                <AlphabeticalFilter
                  onFilter={(d) => {
                    setRangFilter(d);
                    setInputSearch("");
                  }}
                />
              </div>
              {/* {!mobileView && ( */}
              <div className="right_container">
                <span>Set Location</span>
                {cityState.label !== "" && areaState.label !== "" ? (
                  <div
                    className="location"
                    // onClick={() => setShowLocation(true)}
                    onClick={() => setalertShowLocation1(true)}
                    style={{
                      color: "#191716",
                      display: "flex",
                      justifyContent: "space-around",
                    }}
                  >
                    <span style={{ fontSize: "14px" }}>
                      City: {cityState.label?.replace(/_/g, ' ')
                        ?.replace(/\w\S*/g, txt => txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase())}
                    </span>{" "}
                    <span style={{ fontSize: "14px" }}>
                      Area: {areaState.label?.replace(/_/g, ' ')
                        ?.replace(/\w\S*/g, txt => txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase()) === "Wuse Ii" ? "Wuse II" : areaState.label?.replace(/_/g, ' ')
                          ?.replace(/\w\S*/g, txt => txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase())}
                    </span>

                    <span style={{ fontSize: "14px", color: "#163e8c" }}>
                      EDIT
                    </span>

                  </div>
                ) : (
                  <div
                    className="location"
                    onClick={() => setShowLocation(true)}
                  >
                    Search and set your location
                    <img src={dropdown1} alt="icon" />
                  </div>
                )}
              </div>
              {/* // )} */}
            </div>

            <div className="Card_container_list">
              <div className="pathologyCardList">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "wrap",
                    width: "100%",
                    gap: "12px",
                  }}
                >
                  {console.log(popularTest, "popularTest")}
                  {popularTest &&
                    popularTest.data &&
                    popularTest.data.length !== 0
                    ? popularTest.data.map((value, i) => (
                      // value.doc.populartest_y_n == "YES" ?
                      <CardSelectTest
                        index={i}
                        key={i}
                        val={value}
                        heading={value.doc.standardisedtestname}
                        subHeading={value.doc.partnerstestname}
                        des={value.doc.populartestdescription}
                        handleItems={selectTest}
                        handleItemDelete={delSelectedTest}
                      />
                      // :
                      // ''
                    ))
                    : ""}
                </div>

                <div className="pagination_container">
                  {
                    //    <div className="page_container">
                    //    <button
                    //      className="left_btn"
                    //      onClick={() => handleCount1(-1)}
                    //      disabled={count1 === 1}
                    //    >
                    //      <img src={left} alt="icon" />
                    //    </button>
                    //  </div>

                    <div className="page_container">
                      <button
                        className="left_btn"
                        onClick={() => handleCount1(-1)}
                        disabled={count1 === 0}
                      >
                        <img src={left} alt="icon" />
                      </button>
                      {/* <div
                        className="left_btn"
                        onClick={() => handleCount1(-1)}
                      >
                        <img src={left} alt="icon" />
                      </div> */}
                      <div className="no_container">
                        Page <span>{count1 + 1}..</span> of{" "}
                        {popularTest && popularTest.count !== undefined
                          ? Math.ceil(popularTest.count / 10)
                          : ""}
                      </div>
                      <button
                        className="right_btn"
                        onClick={() => handleCount1(1)}
                        disabled={Math.ceil(popularTest.count / 10) <= count1 + 1}
                      >
                        <img src={right} alt="icon" />
                      </button>
                    </div>
                  }
                  {/* {!mobileView && <div className="go_to_page">
                    Go to page
                    <input
                      type="text"
                      className="input_go_page"
                      onChange={(e) => setPageno(e.target.value)}
                    />
                    <div
                      className="next_page_btn"
                      onClick={() => setCount(pageno)}
                    >
                      <img src={right} alt="icon" />
                    </div>
                  </div> || ""} */}
                </div>

                {/* <div className="all_test_lists">
                  <div className="list_container">
                    <div className="heading">all tests lists</div>
                    <div className="txt">
                      Kindly find the rest of all out tests here
                    </div>
                  </div>
                  <div
                    className="view_container"
                    onClick={() => setShowCard(!showCard)}
                  >
                    View */}

                {/* <div
                        className="left_btn"
                        onClick={() => handleCount1(-1)}
                        style={{backgroundColor:"red"}}
                      >
                        <img src={top_btn} alt="icon"
                         style={
                          
                          showCard
                            ? { transform: "rotate(180deg)" }
                            : { transform: "rotate(360deg)" }
                        } />
                      </div> */}

                {/* <img
                      src={ArrowLeft}
                      alt="icon"
                      style={
                        showCard
                          ? { transform: "rotate(180deg)" }
                          : { transform: "rotate(360deg)" }
                      }
                    />
                  </div>
                </div> */}

                {/* {showCard ? (
                  <>
                    {" "}
                    <div className="filter_container">
                      <div
                        className="filter_item"
                        onClick={() => setAllTestRange("A-B")}
                      >
                        A-B
                      </div>
                      <div
                        className="filter_item"
                        onClick={() => setAllTestRange("C-E")}
                      >
                        C-E
                      </div>
                      <div
                        className="filter_item"
                        onClick={() => setAllTestRange("F-H")}
                      >
                        F-H
                      </div>
                      <div
                        className="filter_item"
                        onClick={() => setAllTestRange("I-M ")}
                      >
                        I-M
                      </div>
                      <div
                        className="filter_item"
                        onClick={() => setAllTestRange("N-R")}
                      >
                        N-R
                      </div>
                      <div
                        className="filter_item"
                        onClick={() => setAllTestRange("S-Z")}
                      >
                        S-Z
                      </div>
                    </div>
                    {testListing && testListing?.length !== 0
                      ? testListing?.data?.map((value, i) => (
                        <CardSelectTest
                          index={i}
                          key={i}
                          val={value}
                          heading={value.doc.standardisedtestname}
                          subHeading={value.doc.partnerstestname}
                          des={value.doc.populartestdescription}
                          handleItems={selectTest}
                          handleItemDelete={delSelectedTest}
                        />
                      ))
                      : ""}
                  </>
                ) : (
                  ""
                )} */}
                {/* <div className="pagination_container">
                  {showCard && (
                    <div className="page_container">
                      <div className="left_btn" onClick={() => handleCount(-1)}>
                        <img src={left} alt="icon" />
                      </div>
                      <div className="no_container">
                        Page <span>{count}..</span> of{" "}
                        {testListing && testListing.count !== undefined
                          ? testListing.count
                          : ""}
                      </div>
                      <div className="right_btn" onClick={() => handleCount(1)}>
                        <img src={right} alt="icon" />
                      </div>
                    </div>
                  )} */}

                {/* {!mobileView && <div className="go_to_page">
                    Go to page
                    <input
                      type="text"
                      className="input_go_page"
                      onChange={(e) => setPageno(e.target.value)}
                    />
                    <div
                      className="next_page_btn"
                      onClick={() => setCount(pageno)}
                    >
                      <img src={right} alt="icon" />
                    </div>
                  </div> || ""} */}

                {/* </div> */}
              </div>

              {(!mobileView && (
                <CardSelectedTest
                  type="popular_test"
                  list={selectedRec}
                  del={delSelectedTest}
                  featuredel={handlleRemoveTest}
                  area={area}
                  handleLocPop={handleLocPop}
                />
              )) ||
                ""}
            </div>

            <div className="input_containerrr" ref={focusPoint}>
              <div className="leftContainer">
                {searchData && searchData.length > 0 && (
                  <div className="heading_container">
                    <div className="heading">Search Result</div>
                    <div className="txt">Browse through searched tests</div>
                  </div>
                )}
              </div>
            </div>

            <div className="Card_container_list">
              <div className="pathologyCardList">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "wrap",
                    width: "100%",
                    gap: "12px",
                  }}
                >
                  {searchData && searchData.length !== 0
                    ? searchData.map((value, i) => (
                      <CardSelectTest
                        index={i}
                        key={i}
                        val={value}
                        heading={value.doc.standardisedtestname}
                        subHeading={value.doc.partnerstestname}
                        des={value.doc.populartestdescription}
                        handleItems={selectTest}
                        handleItemDelete={delSelectedTest}
                      />
                    ))
                    : ""}
                </div>
              </div>

              {/* {!mobileView && <CardSelectedTest
                type="popular_test"
                list={selectedRec}
                del={delSelectedTest}
                featuredel={handlleRemoveTest}
                area={area}
                handleLocPop={handleLocPop}
              /> || ""} */}
            </div>
          </div>
        </div>
        {(!mobileView && (
          <div className="container_work">
            <div className="heading">How it works?</div>
            <div className="text">Get your medical tests in 3-simple steps</div>
            <Card />
          </div>
        )) ||
          ""}
        <SliderComponent />
        {(!mobileView && (
          <div className="trustpar">
            <div className="by">
              OUR PARTNERS
            </div>
            <PartnerSlider partner={partner} />
          </div>
        )) ||
          ""}

        <button className="fixedButton" onClick={handleButtonClick}>

          <svg xmlns="http://www.w3.org/2000/svg" height="2em" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16" id="IconChangeColor"> <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" id="mainIconPathAttribute" fill="#ffffff"></path> </svg>
        </button>

        {/* Popup */}
        {showPopup && (
          <div className="popup">
            <p>We're here to assist you! If you have any difficulties finding tests, locating a lab, or have any questions, feel free to reach out to us on WhatsApp at <span style={{ cursor: "grab", color: "#ff5c3c" }}>+2349010996000</span>. Our team is ready to help you find the right diagnostic solutions and ensure a smooth experience.</p>
            <button className="popupButton" onClick={closePopup}>Close</button>
          </div>
        )}


        <Sheet
          isOpen={btmSheet}
          snapPoints={[600, 400, 100, 0]}
          onClose={() => setbtmSheet(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <MobileCardSelectedTest
                // type="landing"
                onClose={() => {
                  setbtmSheet(false);
                }}
                list={selectedRec}
                del={delSelectedTest}
                featuredel={handlleRemoveTest}
                area={area}
              />
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>
        <Sheet
          isOpen={btmLocationSheet}
          snapPoints={[600, 400, 100, 0]}
          onClose={() => setbtmLocationSheet(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <Popup
                city={cities}
                setShowLocation={() => {
                  setbtmLocationSheet(false);
                  setbtmSheet(true);
                }}
                setArea={setArea}
                setSelectedRec={setSelectedRec}
              />{" "}
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>
        {console.log(selectedRec, "selectedRec")}
        {console.log(lanTestes, "selectedRec1")}
        {(mobileView && (
          <FloatingIcon
            onClick={() => {
              area.length == 0 ? setbtmLocationSheet(true) : setbtmSheet(true);
            }}
            count={
              selectedRec
                ? selectedRec?.length
                : 0 + lanTestes?.data
                  ? lanTestes?.data?.length
                  : 0
            }
          />
        )) ||
          ""}
        <Modal show={ShowArea} onHide={handleAreaClose}>
          <Filter />
        </Modal>
        <Modal show={alertShowLocation} onHide={handlealertLocationClose}>
          <div className="parentContainer">
            {/* <div className="popuphead5">Please select your location, before selecting the Test</div> */}
            <div className="popuphead5">Please note that after setting the location, you will need to select the test again to proceed. <br />Click OK to set the location and select the test</div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="compare-button-out">
              <div className="popup_btn" onClick={handleLocationOpen}>Ok</div>&nbsp;&nbsp;&nbsp;
              <div className="popup_btn" onClick={handlealertLocationClose}>Cancel</div>
            </div>
          </div>
        </Modal>
        <Modal show={alertShowLocation1} onHide={handlealertLocationClose1}>
          <div className="parentContainer">
            <div className="popuphead5">Changing the location will reset your previous test selection. Are you sure you want to continue</div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="compare-button-out">
              <div className="popup_btn" onClick={handleLocationOpen1}>Confirm</div>&nbsp;&nbsp;&nbsp;
              <div className="popup_btn" onClick={handlealertLocationClose1}>Cancel</div>
            </div>
          </div>
        </Modal>
        <Modal show={ShowLocation} onHide={handleLocationClose}>
          <Popup
            city={cities}
            setShowLocation={setShowLocation}
            setArea={setArea}
            setSelectedRec={setSelectedRec}
          />
        </Modal>
        <Modal show={mobileTestpopstate} onHide={handlemobileTestpop}>
          <Popup
            city={cities}
            setShowLocation={setShowLocation}
            setArea={setArea}
          />
        </Modal>
        {/* <Chat /> */}
      </Layout>
      <Toast
        text={toastMessage}
        type="error"
        open={toastOpen}
        setClose={() => {
          setToastOpen(false);
        }}
      />
      {loading && <LoaderComponent />}
    </>
  );
};
const FloatingIcon = (props) => {
  console.log(props, "18vkjnlk");
  return (
    <div className="floatingIcon" onClick={() => props.onClick()}>
      <div className="count">{props.count}</div>
      <img alt="icon" src={ficon} />
      {(props.count === 0 && <div className="foverlay"></div>) || ""}
    </div>
  );
};
export default PopularTest;
